import C from './component';

export default C;
